import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import logo from "../../assets/logo/logo-white.png";
import { Link } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";

const Header = () => {
  const sidebarRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const [pageScrolled, setPageScrolled] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
    setShowSidebar(false);
  };

  const handleDropdownClick = (dropdownId) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null); // Close dropdown if it's already open
    } else {
      setOpenDropdown(dropdownId); // Open the clicked dropdown
    }
  };

  const handleDropdownLinkClick = () => {
    setOpenDropdown(null);
    scrollHeader();
  };

  const handleClickOutside = (event) => {
    // If the click happens outside the sidebar, close it
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showSidebar]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      if (scrollTop > 40) {
        setPageScrolled(true);
      } else {
        setPageScrolled(false);
      }
    };

    // Add the event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <nav
        className={
          pageScrolled
            ? "navbar navbar-expand-md page-scrolled"
            : "navbar navbar-expand-md"
        }
      >
        <div className="navbar-container">
          <div className="navigation-container">
            <div className="logo-container">
              <Link
                to="/"
                itemProp="url"
                tabIndex="-1"
                onClick={() => scrollHeader()}
              >
                <img
                  itemProp="logo"
                  alt="logo"
                  width="auto"
                  height="60"
                  nitro-lazy-src="https://cdn-kpbff.nitrocdn.com/BIqbPXrNizxHMrZEuWjiIDigcWJtuMrr/assets/images/optimized/rev-c295274/d3mds3ychln71.cloudfront.net/img/logo.png"
                  className="lazyloaded"
                  decoding="async"
                  nitro-lazy-empty=""
                  id="Mzg0OjE5Mw==-1"
                  src={logo}
                />
              </Link>
            </div>
            {!showSidebar && (
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => setShowSidebar((prev) => !prev)}
              >
                <FaBars />
              </button>
            )}
          </div>
          <div
            ref={sidebarRef}
            className={
              showSidebar
                ? "mobile-navbar show d-block"
                : "mobile-navbar d-none"
            }
          >
            <div className="mobile-view">
              <div className="image-container">
                <Link to="/" onClick={scrollHeader}>
                  <img src={logo} alt="logo" />
                </Link>
              </div>
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => setShowSidebar(false)}
              >
                <FaTimes />
              </button>
            </div>
            <div className="links-container">
              <div className="nav-item">
                <Link to="/about" className="nav-link" onClick={scrollHeader}>
                  Who we are
                </Link>
              </div>
              <div className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => handleDropdownClick("services")}
                  role="button"
                  aria-expanded={openDropdown === "services"}
                >
                  Services
                </a>
                <div
                  className={
                    openDropdown === "services" ? "collapse show" : "collapse"
                  }
                >
                  <ul>
                    <li>
                      <Link
                        to="/service/custom-software-development"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Custom Software Development
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/project-based-outsourcing"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Project Based Outsourcing
                      </Link>
                    </li>

                    <li>
                      <Link
                        to="/service/product-line-printing"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Product Line Printing
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/erp-integration"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        ERP Integration
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/rfid-and-barcode-solutions"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        RFID & Bar Code Solutions
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/identity-management-solution"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Identity Management Solution
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/biometric-and-facial-recognition"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Biometric & Facial Recognition
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/service/machine-vision-solutions"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Machine Vision Solution
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => handleDropdownClick("products")}
                  role="button"
                  aria-expanded={openDropdown === "products"}
                >
                  Products
                </a>
                <div
                  className={
                    openDropdown === "products" ? "collapse show" : "collapse"
                  }
                >
                  <ul>
                    <li>
                      <Link
                        to="/products/cubix"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Cubix
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/active"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/on-service"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        On-Service
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/trackline"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Trackline
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/products/aristi"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Aristi
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="nav-item">
                <a
                  className="nav-link"
                  onClick={() => handleDropdownClick("industries")}
                  role="button"
                  aria-expanded={openDropdown === "industries"}
                >
                  Industries
                </a>
                <div
                  className={
                    openDropdown === "industries" ? "collapse show" : "collapse"
                  }
                >
                  <ul>
                    <li>
                      <Link
                        to="/industry/manufacturing"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Manufacturing
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/health-care"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Health Care
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/chemical"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Chemical
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/pharmaceutical"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Pharmaceutical
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/government"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Government
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/food-and-beverages"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Food and Beverages
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/automobile"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Automobile
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/industry/transport-and-logistic"
                        className="dropdown-item"
                        onClick={handleDropdownLinkClick}
                      >
                        Transport & Logistic
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="nav-item">
                <Link
                  to="contact-us"
                  className="nav-link"
                  onClick={scrollHeader}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
          <div className="desktop-navbar">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link
                  to="/about"
                  className="nav-link"
                  onClick={() => scrollHeader()}
                >
                  Who we are
                </Link>
              </li>
              <li className="nav-item dropdown">
                <p
                  className="nav-link dropdown-toggle"
                  role="button"
                  aria-expanded="false"
                >
                  Services
                </p>
                <div className="services-menu menu-list">
                  <div className="container">
                    <h1>Services &rarr;</h1>
                    <hr />
                    <div className="row">
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/custom-software-development"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Custom Software Development
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/project-based-outsourcing"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Project Based Outsourcing
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/product-line-printing"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Product Line Printing
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/erp-integration"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          ERP Integration
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/rfid-and-barcode-solutions"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          RFID & Bar Code Solutions
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/identity-management-solution"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Identity Management Solution
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/biometric-and-facial-recognition"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Biometric & Facial Recognition
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/service/machine-vision-solutions"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Machine Vision Solution
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item dropdown">
                <p
                  className="nav-link dropdown-toggle"
                  role="button"
                  aria-expanded="false"
                >
                  Products
                </p>
                <div className="products-menu menu-list ">
                  <div className="container">
                    <h1>Products &rarr;</h1>
                    <hr />
                    <div className="row">
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/products/cubix"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Cubix
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/products/active"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Active
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/products/on-service"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          On-Service
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/products/trackline"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Trackline
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/products/aristi"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Aristi
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item dropdown">
                <p
                  className="nav-link dropdown-toggle"
                  role="button"
                  aria-expanded="false"
                >
                  Industry
                </p>
                <div className="industry-menu menu-list">
                  <div className="container">
                    <h1>Industry &rarr;</h1>
                    <hr />
                    <div className="row">
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/manufacturing"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Manufacturing
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/health-care"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Health Care
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/chemical"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Chemical
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/pharmaceutical"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Pharmaceutical
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/government"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Government
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/food-and-beverages"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Food and Beverages
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/automobile"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Automobile
                        </Link>
                      </div>
                      <div className="col-6 col-md-6 col-lg-4">
                        <Link
                          to="/industry/transport-and-logistic"
                          className="dropdown-item"
                          onClick={() => scrollHeader()}
                        >
                          Transport & Logistic
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li className="nav-item">
                <Link
                  to="/contact-us"
                  className="nav-link"
                  onClick={() => scrollHeader()}
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
